import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/allowance-reports/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/supporter/$supporterId/allowance-reports/utilisation",
      params: { supporterId: params.supporterId },
    });
  },
});
